import { useEffect, useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import api from "@/lib/api";

export default function FAQ() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/faqs").then(({ data }) => setItems(data)).catch(() => {}); }, []);

  return (
    <section className="relative section-pad overflow-hidden" data-testid="faq-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-4">
            <div className="overline mb-4">08 · FAQ</div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-[-0.02em] leading-[1]">
              Questions,<br /><span className="italic">answered.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-7 md:col-start-6">
            <Accordion type="single" collapsible className="w-full">
              {items.map((f) => (
                <AccordionItem key={f.id} value={f.id} className="border-b border-[color:var(--border)]" data-testid={`faq-${f.id}`}>
                  <AccordionTrigger className="text-left font-serif text-xl md:text-2xl tracking-tight py-7 hover:no-underline">
                    {f.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-[15px] leading-relaxed text-[color:var(--text-muted)] pb-7 max-w-[620px]">
                    {f.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
